import { gql } from "@apollo/client";

export default gql`
  mutation InviteVendorsToGroup($groupId: ObjectId!, $vendorIds: [ObjectId!]!) {
    inviteVendorsToGroup(groupId: $groupId, vendorIds: $vendorIds) {
      _id
      vendor {
        _id
        logo
        name
        slug
      }
      createdAt
    }
  }
`;
